import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpRequestCancelService } from 'app/_services/httprequestcancel.service';
import { Observable, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestCancelInterceptor implements HttpInterceptor {
  constructor(private httpCancelService: HttpRequestCancelService) {}

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(req).pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()));
  }
}
